import { typedStyles } from '@/utils/styleUtils';

export const mainStyles = typedStyles({
  header: {
    position: 'relative',
    marginBottom: 3,
  },

  backButton: {
    position: 'absolute',
    right: '100%',
    top: -4,
    marginRight: 2,
    color: 'text.primary',
  },

  options: {
    gap: 3,
  },
});

export const selectExistingStyles = typedStyles({
  root: {
    paddingTop: 3,
    gap: 4,
  },

  name: {
    flex: 1,
    fontWeight: 500,
    marginRight: 2,
  },

  last4: {
    flexShrink: 0,
    fontWeight: 500,
    letterSpacing: '6px',
  },
});

export const addNewStyles = typedStyles({
  section: {
    marginTop: 6,
  },

  title: {
    marginBottom: 4,
  },
});
